import React, { useEffect, useRef, useState } from 'react';

// Muted looping video that downloads only when it gets close to the screen and
// pauses while it is out of view, so videos further down don't slow the page.
// Hidden containers (display: none) never load it.
const LazyVideo = ({ src, poster, className, ...rest }) => {
    const ref = useRef(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const video = ref.current;
        if (!video) return undefined;
        if (!('IntersectionObserver' in window)) {
            setLoad(true);
            return undefined;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setLoad(true);
                const playing = video.play();
                if (playing && playing.catch) playing.catch(() => { /* autoplay blocked: the poster stays */ });
            } else if (!video.paused) {
                video.pause();
            }
        }, { rootMargin: '300px 0px' });
        observer.observe(video);
        return () => observer.disconnect();
    }, []);

    return (
        <video
            ref={ref}
            src={load ? src : undefined}
            poster={poster}
            autoPlay={load}
            loop
            muted
            playsInline
            preload="none"
            className={className}
            {...rest}
        />
    );
};

export default LazyVideo;
